<div [class]="containerClass">
  @for (obj of commonService.minimumData(data, showRemainedDataNumber); track obj) {
    <p-chip
      class="pr-5"
      [class.three-in-row]="showRemainedDataNumber === data?.length"
      [label]="objectKey ? obj[objectKey] : obj"
      styleClass="my-chip color-primary pr-5"
      [pTooltip]="tooltipByKey?.length ? obj[tooltipByKey] : ''"
      tooltipPosition="bottom"
    ></p-chip>
  }
  @if (commonService.remainedData(data, showRemainedDataNumber)) {
    <p-chip
      styleClass="my-remain-number-chip color-primary pr-5"
      [label]="commonService.remainedData(data, showRemainedDataNumber)"
      [pTooltip]="commonService.remainedDataTooltipNames(data, objectKey, showRemainedDataNumber)"
      tooltipPosition="bottom"
    ></p-chip>
  }
</div>
